<div *ngIf="isLoadingFilters$ | async" class="global-spinner-container">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<div *ngIf="(isLoadingFilters$ | async) === false" class="content-wrapper">

  <app-stats-ai-mode-toggle 
    [mode]="statsMode"
    (modeChange)="onModeChange($event)">
  </app-stats-ai-mode-toggle>

  <app-statistics-filter-bar
    [filters$]="filters$"
    [statsMode]="statsMode"
    [initialFilters]="restoredFilters"
    (filtersChanged)="onFiltersChanged($event)">
  </app-statistics-filter-bar>

  <app-statistics-tabs
    [statsMode]="statsMode"
    [selectedTabIndex]="selectedTabIndex"
    (tabChanged)="onTabChanged($event)">
  </app-statistics-tabs>

</div>
